// extracted by mini-css-extract-plugin
export var gif = "_fs-0";